module.exports = __webpack_public_path__ + "img/as_4a.8fffffc8.png";